// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

import { isApproveAvailableForApprovalManager, prepareWaitingApprovals, requestTypeLabel } from "../../../company/request-center/request-center.functions";

export class Controller {
    /** @ngInject */
    constructor(RequestCenterService, ShowNoteModal, ConfirmDeleteModal, $state) {
        this.RequestCenterService = RequestCenterService;
        this.ShowNoteModal = ShowNoteModal;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
    }

    $onInit() {
    }

    showNote(requestDto){
        this.ShowNoteModal('Note', requestDto.note);
    }

    approveRequest(requestDto) {
        this.RequestCenterService.approveRequestByApprovalManager(requestDto.id)
            .then(() => this.$state.go('.', {}, {reload: '.'}))
    }

    denyRequest(requestDto) {
        this.ConfirmDeleteModal('Are you sure you want to deny this request')
            .then(() => {
                this.RequestCenterService.denyRequestByApprovalManager(requestDto.id)
                    .then(() => this.$state.go('.', {}, {reload: '.'}))
            })
    }

    getWaitingApprovals(requestDto) {
        return prepareWaitingApprovals(requestDto);
    }

    displayApproveButton(requestDto) {
        return isApproveAvailableForApprovalManager(requestDto);
    }

    getRequestTypeLabel(requestDto) {
        return requestTypeLabel(requestDto.type);
    }

    displayDenyButton(requestDto) {
        return isApproveAvailableForApprovalManager(requestDto);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/approvals/approvals.controller.js